"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationType;
(function (CommunicationType) {
    CommunicationType["Email"] = "Email";
    CommunicationType["Letter"] = "Letter";
})(CommunicationType = exports.CommunicationType || (exports.CommunicationType = {}));
//# sourceMappingURL=CommunicationType.js.map